import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getBreakdownOfficeDetails } from '../../../service/service-gateway';
import { useCommonStore, useSearchStore } from '../../../store/store';
import { buildOfficeDetails } from '../helpers/breakdowns';
import { searchRoutes } from '../../../constants';

export const useOfficeInfo = () => {

    const location = useLocation();
    const [officeDetails, setOfficeDetails] = useState(null);

    const { search, selectedBreakdownOffice, loadedSearchCriteria } = useSearchStore((state) => ({
        search: state[state.selectedModule]?.search,
        selectedBreakdownOffice: state[state.selectedModule]?.breakdowns?.selectedBreakdownOffice,
        loadedSearchCriteria: state[state.selectedModule]?.loadedSearchCriteria
    }));

    const mlsProviders = useCommonStore(state => state.mlsProviders);
    const isAgMovAgentBreakdownRoute = location.pathname === searchRoutes.agentBreakdown;
    const selectedMlsId = search?.mlsId;
    const officeId = selectedBreakdownOffice?.officeId;

    useEffect(() => {
        const getOfficeDetails = async () => {
            try {
                const officeDetailsRow = isAgMovAgentBreakdownRoute && await getBreakdownOfficeDetails(selectedMlsId, officeId);
                const selectedMls = mlsProviders.find(mls => mls.mlsId === selectedMlsId)?.shortDescription;
                const updatedOfficeDetailsRow = { ...officeDetailsRow, mls: selectedMls };
                setOfficeDetails(buildOfficeDetails(updatedOfficeDetailsRow));
            }
            catch (e) {
                console.error("Error fetching office details:", e);
            }
        };

        getOfficeDetails();
    }, [loadedSearchCriteria, officeId]);

    return officeDetails;
};
